<!-- Questo componente necessita di Bootstrap 5.x -->
<template>
  <div class="modal" tabindex="-1" aria-hidden="true" :id="idModal">
    <div class="modal-dialog" :class="dimensioneModal">
        <div class="modal-content">
            <div class="modal-header">
                <slot name="header">
                    <h5 class="modal-title">{{titoloModal}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </slot>
            </div>
            <div class="modal-body">
                <slot></slot>
            </div>
            <div class="modal-footer">
                <slot name="footer">
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal">OK</button>
                </slot>
                
            </div>
        </div>
    </div>
    </div>

</template>

<script>
export default {
    name: "DialogBox",
    props: {
        idModal: String,
        titoloModal: String,
        dimensioneModal: { type:String, default: "" },
    },
    data: function () {
    return {
      
    }
 },
 methods: {
    ProcessaTestoMessaggio() {
    

        let msg = '';
        for(let i=0; i<this.alertMessaggio.length; i++) {
            msg += this.alertMessaggio[i] + " ";
        }
        return msg;
    }    
 },
 mounted: function() {
    
    
 }
}
</script>

<style>

</style>